module.exports = __webpack_public_path__ + "media/src/images/testimonials/03-a96dd8eec415cb155f3056288aa6e960.jpg";